import { FlyerDetailPageEditType } from "../flyer-detail-page-state/flyer-detail-page-state.interface";

export const getFlyerDrawerHeader = (type: FlyerDetailPageEditType) => {
  switch (type) {
    case "page":
      return "Page Details";
    case "position":
      return "Position Details";
    case "comments":
      return "Page Comments";
    default:
      return "";
  }
};
